import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import type { FilterRenderProps } from "../../grid/CompGrid";

export interface GridIsRootFilterPopoverProps extends FilterRenderProps {
  label?: string;
}

export function GridIsRootFilterPopover({
  value,
  onChange,
  label = "Root span",
}: GridIsRootFilterPopoverProps) {
  const v = value as boolean | null | undefined;
  const displayValue = v === true ? "true" : v === false ? "false" : "all";

  return (
    <FormControl size="small" sx={{ minWidth: 140 }}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={displayValue}
        label={label}
        onChange={(e) => {
          const x = e.target.value;
          onChange(x === "all" ? null : x === "true");
        }}
      >
        <MenuItem value="all">All</MenuItem>
        <MenuItem value="true">Root only</MenuItem>
        <MenuItem value="false">Child only</MenuItem>
      </Select>
    </FormControl>
  );
}
